import { KIT_IMAGE } from "../data/eventData";
import { MaskLine, Reveal } from "./Motion";

const KIT_ITEMS = [
  "Mochila executiva PS27 para notebook",
  "9ª edição “Licitação Pública e Contrato Administrativo” · Editora Fórum",
  "Apostila de Workshops",
  "Bloco de Anotações",
  "Credencial exclusiva de participante",
  "Copo térmico e caneta premium",
];

export default function KitShowcase() {
  return (
    <section id="kit" className="relative py-20 sm:py-28 overflow-hidden" data-testid="kit-section">
      {/* Aurora suave atrás do kit */}
      <div className="absolute inset-0 bg-[radial-gradient(820px_560px_at_72%_52%,rgba(0,142,255,0.16),transparent_62%)] pointer-events-none" />
      <div className="absolute inset-0 bg-[radial-gradient(600px_420px_at_20%_20%,rgba(0,200,255,0.06),transparent_65%)] pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center">
          {/* Headline + conteúdo · esquerda */}
          <div className="order-2 lg:order-1 text-left">
            <h2 className="heading-lg" data-testid="kit-heading">
              <MaskLine inView>Kit</MaskLine>
              <MaskLine inView delay={0.1}>
                <span className="text-gradient-blue">Oficial PS27</span>
              </MaskLine>
            </h2>
            <Reveal delay={0.18}>
              <p className="mt-5 text-white/65 text-sm sm:text-base leading-relaxed max-w-lg">
                Todo participante presencial recebe o kit oficial do evento, pensado para
                acompanhar você durante e depois do PS27.
              </p>
            </Reveal>

            <ul className="mt-8 space-y-3 max-w-lg">
              {KIT_ITEMS.map((item, i) => (
                <Reveal key={i} delay={0.24 + i * 0.07}>
                  <li
                    className="flex items-center gap-3.5 rounded-2xl glass-static px-4 py-3 text-sm text-white/85"
                    data-testid={`kit-item-${i}`}
                  >
                    <span className="h-1.5 w-1.5 rounded-full bg-brand-cyan shrink-0" />
                    {item}
                  </li>
                </Reveal>
              ))}
            </ul>
          </div>

          {/* Kit · direita, estático com efeito no hover */}
          <Reveal className="relative order-1 lg:order-2">
            <div className="group relative flex items-center justify-center py-6 sm:py-10" data-testid="kit-image-wrap">
              {/* Halo de vidro atrás do kit */}
              <div className="absolute inset-x-8 sm:inset-x-14 top-1/2 -translate-y-1/2 aspect-square rounded-full bg-[radial-gradient(closest-side,rgba(0,142,255,0.22),rgba(0,142,255,0.05)_55%,transparent_75%)] transition-opacity duration-700 group-hover:opacity-100 opacity-70 pointer-events-none" />
              <img
                src={KIT_IMAGE}
                alt="Kit Oficial PS27: mochila, livro, apostila, bloco de anotações, credencial, copo térmico e caneta"
                loading="lazy"
                decoding="async"
                className="relative w-full h-auto transition-[transform,filter] duration-700 ease-out group-hover:scale-[1.04] group-hover:-rotate-1 [filter:drop-shadow(0_54px_54px_rgba(2,8,23,0.65))] group-hover:[filter:drop-shadow(0_70px_70px_rgba(0,60,140,0.45))]"
                data-testid="kit-image"
              />
              {/* Sombra de palco sob o kit */}
              <div className="absolute bottom-2 sm:bottom-4 left-1/2 -translate-x-1/2 w-3/4 h-10 rounded-[100%] bg-black/50 blur-2xl transition-all duration-700 group-hover:w-4/5 group-hover:bg-black/40 pointer-events-none" />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
